<template>
  <div class="additional-answers w-100">
    <div
      class="mb-2 w-100"
      v-for="(answer, index) in choiceConfig"
      :key="answer.id"
    >
      <div
        class="d-flex justify-content-end"
        v-if="isAnswerVisible(getAnswerForChoice(participant, choice), index)"
      >
        <template v-if="!isParticipantAllowedToSetTheAnswer(answer)">
          <div class="answer-is-allowed align-items-end">
            <div style="word-wrap: break-word;" class="text-size-12">
              {{ answer.labelValue }}
            </div>
            <div style="word-wrap: break-word;" class="text-size-16 pb-2">
              {{
                getPreferenceAnswerValueForDisplay(participant, choice, index)
              }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="d-flex w-100 justify-content-end">
            <InputSelectField
              :label="answer.labelValue"
              :isCenetered="false"
              :options="answer.values.map((option) => option.value)"
              :value="getPreferenceAnswer(participant, choice.id, index)"
              @select="onSelectOptions($event, participant, choice.id, index)"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { renderMixin } from '../mixins/RenderMixins';
import { answerMixin } from '../mixins/AnswerMixins.js';
// import vSelect from 'vue-select';
export default {
  name: 'RenderAnswerSelection',
  mixins: [renderMixin, answerMixin],
  components: {},

  props: {
    participant: {
      type: Object,
      mandatory: true,
    },
    choice: {
      type: Object,
      mandatory: true,
    },
    isCentered: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    answerOptions(answer) {
      let list = [];

      let id = 1;
      for (const option of answer.values) {
        let item = {};
        item.code = id++;
        item.title = option.value;
        console.info('item:', item);
        list.push(item);
      }
      return list;
    },

    onMySelectOptions($event, participant, choiceId, index) {
      console.log('onMySelectOptions', $event, participant, choiceId, index);
    },
  },
};
</script>

<style lang="scss">
.additional-answers {
  font-size: 14px;
  display: flex;
}

.answer-is-allowed {
  display: flex;
  flex-direction: column;
}
</style>
